import { type } from '@/utils/type'

export const GLIDER_SEND_IRIS_COMMAND_REQUEST = type('GLIDER_SEND_IRIS_COMMAND_REQUEST')
export const GLIDER_SEND_IRIS_COMMAND_SUCCESS = type('GLIDER_SEND_IRIS_COMMAND_SUCCESS')
export const GLIDER_SEND_IRIS_COMMAND_ERROR = type('GLIDER_SEND_IRIS_COMMAND_ERROR')


export const GLIDER_REQUEST = type('GLIDER_REQUEST')
export const GLIDER_SUCCESS = type('GLIDER_SUCCESS')
export const GLIDER_ERROR = type('GLIDER_ERROR')

export const GLIDER_ENSURE_LIST = type('GLIDER_ENSURE_LIST')

export const GLIDER_SELECT_DETAIL_REQUEST = type('GLIDER_SELECT_DETAIL_REQUEST')
export const GLIDER_SELECT_DETAIL_SUCCESS = type('GLIDER_SELECT_DETAIL_SUCCESS')
export const GLIDER_SELECT_DETAIL_ERROR = type('GLIDER_SELECT_DETAIL_ERROR')
export const GLIDER_SELECT_DETAIL = type('GLIDER_SELECT_DETAIL')

export const GLIDER_SAVE_REQUEST = type('GLIDER_SAVE_REQUEST')
export const GLIDER_SAVE_SUCCESS = type('GLIDER_SAVE_SUCCESS')
export const GLIDER_SAVE_ERROR = type('GLIDER_SAVE_ERROR')

export const GLIDER_DELETE_REQUEST = type('GLIDER_DELETE_REQUEST')
export const GLIDER_DELETE_SUCCESS = type('GLIDER_DELETE_SUCCESS')
export const GLIDER_DELETE_ERROR = type('GLIDER_DELETE_ERROR')

export const GLIDER_EXTERNAL_UPDATE = type('GLIDER_EXTERNAL_UPDATE')

export const GLIDER_UPDATE_MODIFIED_ADM = type('GLIDER_UPDATE_MODIFIED_ADM')
export const GLIDER_CANCEL_MODIFIED_ADM = type('GLIDER_CANCEL_MODIFIED_ADM')

export const GLIDER_UPDATE_FILTER_ADM = type('GLIDER_UPDATE_FILTER_ADM')

export const GLIDER_IRIS_NSD_REQUEST = type('GLIDER_IRIS_NSD_REQUEST')
export const GLIDER_IRIS_NSD_SUCCESS = type('GLIDER_IRIS_NSD_SUCCESS')
export const GLIDER_IRIS_NSD_ERROR = type('GLIDER_IRIS_NSD_ERROR')

export const GLIDER_IRIS_NSD_SAVE_REQUEST = type('GLIDER_IRIS_NSD_SAVE_REQUEST')
export const GLIDER_IRIS_NSD_SAVE_SUCCESS = type('GLIDER_IRIS_NSD_SAVE_SUCCESS')
export const GLIDER_IRIS_NSD_SAVE_ERROR = type('GLIDER_IRIS_NSD_SAVE_ERROR')
export const GLIDER_IRIS_NSD_ENABLE_REQUEST = type('GLIDER_IRIS_NSD_ENABLE_REQUEST')

export const GLIDER_UPDATE_MODIFIED_NSD = type('GLIDER_UPDATE_MODIFIED_NSD')
export const GLIDER_CANCEL_MODIFIED_NSD = type('GLIDER_CANCEL_MODIFIED_NSD')

export const GLIDER_IRIS_FILE_TRANSFERT_REQUEST = type('GLIDER_IRIS_FILE_TRANSFERT_REQUEST')
export const GLIDER_IRIS_FILE_TRANSFERT_SUCCESS = type('GLIDER_IRIS_FILE_TRANSFERT_SUCCESS')
export const GLIDER_IRIS_FILE_TRANSFERT_ERROR = type('GLIDER_IRIS_FILE_TRANSFERT_ERROR')

export const GLIDER_IRIS_FILE_TRANSFERT_SAVE_REQUEST = type('GLIDER_IRIS_FILE_TRANSFERT_SAVE_REQUEST')
export const GLIDER_IRIS_FILE_TRANSFERT_SAVE_SUCCESS = type('GLIDER_IRIS_FILE_TRANSFERT_SAVE_SUCCESS')
export const GLIDER_IRIS_FILE_TRANSFERT_SAVE_ERROR = type('GLIDER_IRIS_FILE_TRANSFERT_SAVE_ERROR')
export const GLIDER_IRIS_FILE_TRANSFERT_ENABLE_REQUEST = type('GLIDER_IRIS_FILE_TRANSFERT_ENABLE_REQUEST')

export const GLIDER_UPDATE_MODIFIED_FILE_TRANSFERT = type('GLIDER_UPDATE_MODIFIED_FILE_TRANSFERT')
export const GLIDER_CANCEL_MODIFIED_FILE_TRANSFERT = type('GLIDER_CANCEL_MODIFIED_FILE_TRANSFERT')

export const GLIDER_IRIS_SINGLE_WAY_POINT_REQUEST = type('GLIDER_IRIS_SINGLE_WAY_POINT_REQUEST')
export const GLIDER_IRIS_SINGLE_WAY_POINT_SUCCESS = type('GLIDER_IRIS_SINGLE_WAY_POINT_SUCCESS')
export const GLIDER_IRIS_SINGLE_WAY_POINT_ERROR = type('GLIDER_IRIS_SINGLE_WAY_POINT_ERROR')

export const GLIDER_IRIS_SINGLE_WAY_POINT_SAVE_REQUEST = type('GLIDER_IRIS_SINGLE_WAY_POINT_SAVE_REQUEST')
export const GLIDER_IRIS_SINGLE_WAY_POINT_SAVE_SUCCESS = type('GLIDER_IRIS_SINGLE_WAY_POINT_SAVE_SUCCESS')
export const GLIDER_IRIS_SINGLE_WAY_POINT_SAVE_ERROR = type('GLIDER_IRIS_SINGLE_WAY_POINT_SAVE_ERROR')
export const GLIDER_IRIS_SINGLE_WAY_POINT_ENABLE_REQUEST = type('GLIDER_IRIS_SINGLE_WAY_POINT_ENABLE_REQUEST')

export const GLIDER_UPDATE_MODIFIED_SINGLE_WAY_POINT = type('GLIDER_UPDATE_MODIFIED_SINGLE_WAY_POINT')
export const GLIDER_CANCEL_MODIFIED_SINGLE_WAY_POINT = type('GLIDER_CANCEL_MODIFIED_SINGLE_WAY_POINT')

export const GLIDER_IRIS_FTP_REQUEST = type('GLIDER_IRIS_FTP_REQUEST')
export const GLIDER_IRIS_FTP_SUCCESS = type('GLIDER_IRIS_FTP_SUCCESS')
export const GLIDER_IRIS_FTP_ERROR = type('GLIDER_IRIS_FTP_ERROR')

export const GLIDER_IRIS_FTP_SAVE_REQUEST = type('GLIDER_IRIS_FTP_SAVE_REQUEST')
export const GLIDER_IRIS_FTP_SAVE_SUCCESS = type('GLIDER_IRIS_FTP_SAVE_SUCCESS')
export const GLIDER_IRIS_FTP_SAVE_ERROR = type('GLIDER_IRIS_FTP_SAVE_ERROR')
export const GLIDER_IRIS_FTP_ENABLE_REQUEST = type('GLIDER_IRIS_FTP_ENABLE_REQUEST')

export const GLIDER_UPDATE_MODIFIED_FTP = type('GLIDER_UPDATE_MODIFIED_FTP')
export const GLIDER_CANCEL_MODIFIED_FTP = type('GLIDER_CANCEL_MODIFIED_FTP')

export const GLIDER_IRIS_RSYNC_REQUEST = type('GLIDER_IRIS_RSYNC_REQUEST')
export const GLIDER_IRIS_RSYNC_SUCCESS = type('GLIDER_IRIS_RSYNC_SUCCESS')
export const GLIDER_IRIS_RSYNC_ERROR = type('GLIDER_IRIS_RSYNC_ERROR')

export const GLIDER_IRIS_RSYNC_SAVE_REQUEST = type('GLIDER_IRIS_RSYNC_SAVE_REQUEST')
export const GLIDER_IRIS_RSYNC_SAVE_SUCCESS = type('GLIDER_IRIS_RSYNC_SAVE_SUCCESS')
export const GLIDER_IRIS_RSYNC_SAVE_ERROR = type('GLIDER_IRIS_RSYNC_SAVE_ERROR')
export const GLIDER_IRIS_RSYNC_ENABLE_REQUEST = type('GLIDER_IRIS_RSYNC_ENABLE_REQUEST')

export const GLIDER_UPDATE_MODIFIED_RSYNC = type('GLIDER_UPDATE_MODIFIED_RSYNC')
export const GLIDER_CANCEL_MODIFIED_RSYNC = type('GLIDER_CANCEL_MODIFIED_RSYNC')

export const GLIDER_IRIS_EXPECTED_NMEA_REQUEST = type('GLIDER_IRIS_EXPECTED_NMEA_REQUEST')
export const GLIDER_IRIS_EXPECTED_NMEA_SUCCESS = type('GLIDER_IRIS_EXPECTED_NMEA_SUCCESS')
export const GLIDER_IRIS_EXPECTED_NMEA_ERROR = type('GLIDER_IRIS_EXPECTED_NMEA_ERROR')

export const GLIDER_IRIS_EXPECTED_NMEA_SAVE_REQUEST = type('GLIDER_IRIS_EXPECTED_NMEA_SAVE_REQUEST')
export const GLIDER_IRIS_EXPECTED_NMEA_SAVE_SUCCESS = type('GLIDER_IRIS_EXPECTED_NMEA_SAVE_SUCCESS')
export const GLIDER_IRIS_EXPECTED_NMEA_SAVE_ERROR = type('GLIDER_IRIS_EXPECTED_NMEA_SAVE_ERROR')

export const GLIDER_IRIS_EXPECTED_NMEA_ENABLE_REQUEST = type('GLIDER_IRIS_EXPECTED_NMEA_ENABLE_REQUEST')

export const GLIDER_UPDATE_MODIFIED_EXPECTED_NMEA = type('GLIDER_UPDATE_MODIFIED_EXPECTED_NMEA')
export const GLIDER_CANCEL_MODIFIED_EXPECTED_NMEA = type('GLIDER_CANCEL_MODIFIED_EXPECTED_NMEA')

export const GLIDER_MODCONF_UPDATE = type('GLIDER_MODCONF_UPDATE')
